export default __webpack_public_path__ + "static/media/43.d64329c0.jpg";